import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiChannel } from 'core/constants';

import { ModelBase } from 'store/model-base';
import { buildHeaders, XmStore } from 'core/services';

import { StoreAction } from 'store/actions';
import { NowBuyFlow } from './models/buy-flow';


@Injectable()
export class NowBuyFlowApi {
    public static sendToBuyFlow(_xmStore: XmStore, http: HttpClient, params: ApiParams): Observable<NowBuyFlow> {
        return http.post('/now/buyflow/mobile', params.intent, {
            headers: buildHeaders({ apiChannel: ApiChannel.SSM_GATEWAY })
        }).pipe(
            map((response: NowBuyFlow) =>
                NowBuyFlow.create<NowBuyFlow>({ ...response, lineId: params.lineId }))
        );
    }
}

ModelBase.persistMapping[StoreAction.POST_SALES_INTENT] = NowBuyFlowApi.sendToBuyFlow;
